import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Modal } from './../../../app/common/sharedComponents/Modal';
import { Headline3, Headline4 } from './../../../app/common/typography';
import { ButtonLarge } from './../../../app/common/sharedComponents/buttons/ButtonLarge';

const TitleContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.l};
  text-align: center;
`;

const TextContainer = styled.div`
  padding: ${({ theme }) => `${theme.spacing.xs} ${theme.spacing.none} ${theme.spacing.md}`};
`;

const ButtonContainer = styled.div`
  margin: ${({ theme }) => `${theme.spacing.l} ${theme.spacing.none}`};
`;

interface AccessCodeExpiredModalProps {
  isOpen: boolean;
}

export function AccessCodeExpiredModal<AccessCodeExpiredModalProps> ({
  isOpen,
}) {
  const { t } = useTranslation();

  const handleClose = () => {
    window.location.href = '/login';
  };

  return (
    <Modal isOpen={isOpen} canCloseModal={false}>
      <TitleContainer>
        <Headline3>
          {t('COMMON.REGISTRATION.ERRORS.ACCESS_CODE_EXPIRED.TITLE')}
        </Headline3>
      </TitleContainer>
      <TextContainer>
        <Headline4 color="dimGray">
          {t('COMMON.REGISTRATION.ERRORS.ACCESS_CODE_EXPIRED.MESSAGE')}
        </Headline4>
      </TextContainer>
      <hr color="#9797AA" />
      <ButtonContainer>
        <ButtonLarge
          onClick={handleClose}
          title={t('COMMON.OUTSIDE.BUTTONS.CLOSE')}
          backgroundColor="oxfordBlue"
        />
      </ButtonContainer>
    </Modal>
  );
}
